const driveContainer = "_aradoknz3t";

export { driveContainer };
import "./modal.style.linaria.module.css";
//# sourceMappingURL=modal.style.js.map
